var data = {
  "body": "<g fill=\"none\"><path d=\"M12 3v12m0-12L8 7m4-4l4 4\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M2 17l.621 2.485A2 2 0 0 0 4.561 21H19.439a2 2 0 0 0 1.94-1.515L22 17\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g>",
  "width": 24,
  "height": 24
};
exports.__esModule = true;
exports.default = data;